import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FlexboxGrid } from 'rsuite';
import styled from 'styled-components';

import { useOnAddOfferPush } from '../../App/hooks/onAddOfferPush.hook';
import { AppRoutes } from '../../Routing/routing.model';

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.primary};
  background-image: url('/images/banners/banner.svg');
  background-size: cover;
  background-repeat: no-repeat;
  padding: 24px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 380px; /* Zwiększono minimalną wysokość */
`;

const Heading = styled(FlexboxGrid)`
  text-align: center;
  height: 100%;
  margin: 5px;
  padding: 5px;
`;

const CarouselWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;
  height: 380px; /* Zwiększono wysokość */
`;

const CarouselContainer = styled.div<{ translateX: number }>`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(${(props) => props.translateX}%);
  height: 100%; /* Dostosowano wysokość do kontenera */
  width: 100%;
  margin: 0;
  padding: 0;
`;

const Slide = styled.div`
  min-width: 100%;
  box-sizing: border-box;
  text-align: center;
  color: white;

  height: 100%; /* Zwiększono wysokość */
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const HomepageHeading: React.FC = () => {
  return (
    <Wrapper>
      <CustomCarousel />
    </Wrapper>
  );
};

export const CustomCarousel: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const { push } = useHistory();
  const { t } = useTranslation();

  const onAddOfferPush = useOnAddOfferPush();

  const slides = [
    <Heading justify="center" key="slide5" style={{ position: 'relative', width: '100%' }}>
      <div className="relative z-10 bg-gradient-to-r from-blue-500 to-green-500 text-white rounded-xl shadow-md flex flex-col justify-center items-center h-full w-full">
        <h2 className="text-2xl font-bold mb-4 text-center md:text-3xl lg:text-4xl lg:w-2/4">
          {t('BANNER.BLOCKCHAIN.TRUST.HEADING')}
        </h2>
        <p className="text-lg mb-6 text-center mx-auto md:text-xl lg:w-3/4">
          {t('BANNER.BLOCKCHAIN.TRUST.DESCRIPTION')}
        </p>
      </div>
    </Heading>,
    <Heading justify="center" key="slide6" style={{ position: 'relative', width: '100%' }}>
      <div className="relative z-10 bg-gradient-to-r   from-indigo-600 via-blue-500 to-blue-700  text-white p-3 md:p-5 rounded-xl shadow-md h-full w-full ">
        <div className="flex flex-col justify-between items-center h-5/6 mx-auto md:h-full md:flex-row md:w-full lg:w-5/6 xl:justify-around  ">
          <div className="flex flex-col item mb-2">
            <div className="icon-container relative">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#2640A2"
                width="25"
                height="32"
                viewBox="0 0 25 32">
                <path d="M24 0c0.625 0 1.143 0.518 1.143 1.143v29.714c0 0.625-0.518 1.143-1.143 1.143h-22.857c-0.625 0-1.143-0.518-1.143-1.143v-29.714c0-0.625 0.518-1.143 1.143-1.143h22.857zM9.143 5.143v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571zM9.143 9.714v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571zM9.143 14.286v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571zM9.143 18.857v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571zM6.857 24.571v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM6.857 20v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM6.857 15.429v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM6.857 10.857v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM6.857 6.286v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM16 29.143v-3.429c0-0.321-0.25-0.571-0.571-0.571h-5.714c-0.321 0-0.571 0.25-0.571 0.571v3.429c0 0.321 0.25 0.571 0.571 0.571h5.714c0.321 0 0.571-0.25 0.571-0.571zM16 20v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM16 15.429v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM16 10.857v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM16 6.286v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM20.571 24.571v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM20.571 20v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM20.571 15.429v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM20.571 10.857v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571zM20.571 6.286v-1.143c0-0.321-0.25-0.571-0.571-0.571h-1.143c-0.321 0-0.571 0.25-0.571 0.571v1.143c0 0.321 0.25 0.571 0.571 0.571h1.143c0.321 0 0.571-0.25 0.571-0.571z"></path>
              </svg>
            </div>
            <div className="text-container">
              <p className="text-base mt-6 mobile">{t('BANNER.EXPLORE_OFFERS.HEADING')}</p>
              <p className="text-base mt-6 md:text-2xl xl:text-3xl desktop w-64">
                {t('BANNER.EXPLORE_OFFERS.HEADING')}
              </p>
            </div>
          </div>
          <div className="flex flex-col item mb-2">
            <div className="icon-container relative">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#2640A2"
                width="30"
                height="32"
                viewBox="0 0 30 32">
                <path d="M25.143 16.607v5.679c0 2.839-2.304 5.143-5.143 5.143h-14.857c-2.839 0-5.143-2.304-5.143-5.143v-14.857c0-2.839 2.304-5.143 5.143-5.143h14.857c0.714 0 1.429 0.143 2.089 0.446 0.161 0.071 0.286 0.232 0.321 0.411 0.036 0.196-0.018 0.375-0.161 0.518l-0.875 0.875c-0.107 0.107-0.268 0.179-0.411 0.179-0.054 0-0.107-0.018-0.161-0.036-0.268-0.071-0.536-0.107-0.804-0.107h-14.857c-1.571 0-2.857 1.286-2.857 2.857v14.857c0 1.571 1.286 2.857 2.857 2.857h14.857c1.571 0 2.857-1.286 2.857-2.857v-4.536c0-0.143 0.054-0.286 0.161-0.393l1.143-1.143c0.125-0.125 0.268-0.179 0.411-0.179 0.071 0 0.143 0.018 0.214 0.054 0.214 0.089 0.357 0.286 0.357 0.518zM29.268 7.875l-14.536 14.536c-0.571 0.571-1.464 0.571-2.036 0l-7.679-7.679c-0.571-0.571-0.571-1.464 0-2.036l1.964-1.964c0.571-0.571 1.464-0.571 2.036 0l4.696 4.696 11.554-11.554c0.571-0.571 1.464-0.571 2.036 0l1.964 1.964c0.571 0.571 0.571 1.464 0 2.036z"></path>
              </svg>
            </div>
            <div className="text-container">
              <p className="text-base  mt-6 md:text-2xl xl:text-3xl "> {t('BANNER.MAKE_SURE')}</p>
            </div>
          </div>
          <div className="flex flex-col item mb-2">
            <div className="icon-container relative">
              <svg
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                fill="#2640A2"
                width="41"
                height="32"
                viewBox="0 0 41 32">
                <path d="M3.429 20.571c1.5 0 1.5-2.286 0-2.286s-1.5 2.286 0 2.286zM29.732 19.536c-1.411-1.839-2.786-3.714-4.393-5.393l-2.232 2.5c-1.964 2.232-5.482 2.179-7.393-0.107-1.357-1.643-1.357-4 0.036-5.625l3.161-3.679c-1.107-0.571-2.446-0.375-3.643-0.375-1.054 0-2.071 0.429-2.821 1.179l-2.821 2.821h-2.768v9.714c0.786 0 1.5-0.107 2.125 0.5l5.304 5.214c1.089 1.054 2.5 1.982 4.054 1.982 0.804 0 1.661-0.268 2.232-0.839 1.339 0.464 2.893-0.286 3.304-1.661 0.857 0.071 1.643-0.196 2.268-0.786 0.411-0.375 0.946-1.125 0.893-1.714 0.161 0.161 0.554 0.179 0.768 0.179 2.125 0 3.232-2.232 1.929-3.911zM32.571 20.571h1.714v-9.143h-1.661l-2.804-3.214c-0.75-0.857-1.875-1.357-3.018-1.357h-2.982c-1 0-1.964 0.446-2.607 1.196l-3.732 4.339c-0.661 0.786-0.661 1.893-0.018 2.679 1.018 1.214 2.893 1.232 3.946 0.054l3.446-3.893c0.821-0.911 2.321-0.054 1.946 1.107 0.679 0.786 1.411 1.554 2.071 2.339 0.893 1.107 1.75 2.268 2.625 3.393 0.554 0.714 0.964 1.571 1.071 2.5zM37.714 20.571c1.5 0 1.5-2.286 0-2.286s-1.5 2.286 0 2.286zM41.143 10.286v11.429c0 0.625-0.518 1.143-1.143 1.143h-7.75c-0.643 1.554-2.054 2.589-3.696 2.821-0.768 1.125-1.946 1.982-3.268 2.268-0.982 1.25-2.571 2-4.161 1.893-2.946 1.661-6.268 0.214-8.464-1.946l-5.125-5.036h-6.393c-0.625 0-1.143-0.518-1.143-1.143v-12c0-0.625 0.518-1.143 1.143-1.143h7.518c2.071-2.071 3.5-4 6.607-4h2.089c1.161 0 2.286 0.357 3.232 1 0.946-0.643 2.071-1 3.232-1h2.982c3.393 0 4.804 2.214 6.857 4.571h6.339c0.625 0 1.143 0.518 1.143 1.143z"></path>
              </svg>
            </div>
            <div className="text-container">
              <p className="text-base mt-6 mobile"> {t('BANNER.SIGN_LEASE.HEADING')}</p>
              <p className="text-base mt-6 md:text-2xl  xl:text-3xl desktop w-64">{t('BANNER.SIGN_LEASE.HEADING')}</p>
            </div>
          </div>
        </div>
      </div>
      {/*
      <img
        src="/images/assets/autopromocja1.png"
        alt="Szukasz pracy?"
        className="w-11/12 h-full rounded-lg object-cover"
      /> */}
    </Heading>,
    <Heading justify="center" key="slide2" style={{ position: 'relative', width: '100%' }}>
      <div className="relative z-10 bg-gradient-to-b from-green-500 to-green-800 text-white p-5 rounded-xl shadow-md flex flex-col justify-center items-center h-full ">
        <h2 className="text-2xl font-bold mb-4 text-center md:text-3xl lg:text-4xl">
          {t('BANNER.SAFE_AGREEMENT.HEADING')}
        </h2>
        <p className="text-lg mb-6 text-center  md:text-xl lg:w-3/4">{t('BANNER.SAFE_AGREEMENT.DESCRIPTION')}</p>
        <button
          className="bg-white text-green-700 font-bold py-3 px-6 rounded-full hover:bg-gray-200 transition duration-300  md:text-xl"
          onClick={() => push(AppRoutes.OFFERS)}>
          {t('BANNER.SAFE_AGREEMENT.BUTTON')}
        </button>
      </div>
    </Heading>,

    <Heading justify="center" key="slide3" style={{ position: 'relative', width: '100%' }}>
      <div className="relative z-10 bg-gradient-to-r from-blue-500 to-blue-900 text-white c p-5 rounded-xl shadow-md flex flex-col justify-center items-center h-full ">
        <div>
          <h2 className="text-2xl font-bold mb-4 text-center md:text-3xl lg:text-4xl">
            {t('BANNER.RENT_FASTER.HEADING')}
          </h2>
          <p className="text-lg mb-6 text-center mx-auto md:text-xl lg:w-3/4">{t('BANNER.RENT_FASTER.DESCRIPTION')}</p>
          <button
            className="bg-white text-blue-600  font-bold py-3 px-6 rounded-full hover:bg-gray-100 transition-all  md:text-xl"
            onClick={onAddOfferPush}>
            {t('BANNER.RENT_FASTER.BUTTON')}
          </button>
        </div>
      </div>
    </Heading>,

    <Heading justify="center" key="slide4" style={{ position: 'relative', width: '100%' }}>
      <div className="relative z-10 text-white p-8 h-full items-end flex">
        <div>
          <h2 className="text-2xl font-bold mb-4 text-center md:text-3xl lg:text-4xl">
            {t('BANNER.FIND_RENT.HEADING')}
          </h2>
          <p className="text-lg mb-6 text-center mx-auto md:text-xl lg:w-3/4">{t('BANNER.FIND_RENT.DESCRIPTION')}</p>
        </div>
      </div>

      <img
        src="/images/assets/pexels-khwanchai.jpg"
        alt="Wchodzisz, Znajdujesz, Najmujesz"
        className="w-full h-full object-cover absolute inset-0 z-0 rounded-lg "
        style={{ filter: 'brightness(0.5)' }}
      />
    </Heading>,
    // <Heading justify="center" key="slide5" style={{ position: 'relative', width: '100%' }}>
    //   <div className="relative z-10 bg-gradient-to-r from-red-500 to-yellow-500 text-white p-10 rounded-xl shadow-md flex flex-col justify-center items-center h-full w-full">
    //     <h2 className="text-5xl font-extrabold mb-4 text-center">Wielki Moment Nadchodzi</h2>
    //     <p className="text-lg mb-6 text-center">Przygotuj się na wyjątkowe wydarzenie! Pozostało niewiele czasu...</p>
    //     <Countingdown />
    //   </div>
    // </Heading>,

    // <Heading justify="center" key="slide6" style={{ position: 'relative', width: '100%' }}>
    //   <div className="text-gray-700  z-10 m-4 h-full rounded-lg ">
    //     <h1 className="text-5xl font-extrabold text-left w-1/3">
    //       {t('BANNER.JOIN_US.HEADING')}{' '}
    //       <a className="text-blue-700" href="https://najmuje.com">
    //         najmuje.com
    //       </a>
    //     </h1>
    //     <h2 className="font-bold text-xl mt-4 text-left w-1/3">
    //       {t('BANNER.JOIN_US.DESCRIPTION')}
    //       <Button type="primary" size={'large'} className="my-8" onClick={handleJoin}>
    //         {t('BANNER.JOIN_US.BUTTON')}
    //       </Button>
    //     </h2>
    //   </div>
    //   <img
    //     src="/images/assets/pexels-olly-cropped.jpg"
    //     alt="Szukasz pracy?"
    //     className="w-full h-full object-cover absolute inset-0 z-0 rounded-lg  "
    //     style={{ filter: 'brightness(0.8)' }}
    //   />
    // </Heading>,
    <Heading justify="center" key="slide5" style={{ position: 'relative', width: '100%' }}>
      <div className="relative z-10 bg-gradient-to-r from-yellow-500 to-pink-500 text-white 4 rounded-xl shadow-md flex flex-col justify-center items-center h-full w-full">
        <h2 className="text-2xl font-bold mb-4 text-center md:text-3xl lg:text-4xl  lg:w-2/4">
          {t('BANNER.TIME_MONEY.HEADING')}
        </h2>
        <p className="text-lg mb-6 text-center mx-auto md:text-xl lg:w-3/4">{t('BANNER.TIME_MONEY.DESCRIPTION')}</p>
        <a
          href="https://web.najmuje.com"
          target="_blank"
          rel="noopener noreferrer" // Zabezpiecza przed zagrożeniami związanymi z nową kartą
          className="bg-white text-purple-600 font-bold py-3 px-6 rounded-full hover:bg-gray-100 transition-all">
          {t('BANNER.TIME_MONEY.BUTTON')}
        </a>
      </div>
    </Heading>,
  ];

  const totalSlides = slides.length;

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  // const prevSlide = () => {
  //   setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  // };

  useEffect(() => {
    const interval = setInterval(nextSlide, 8000); // Automatyczna zmiana co 8 sekund
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <CarouselWrapper>
        <CarouselContainer translateX={-currentSlide * 100}>
          {slides.map((slide, index) => (
            <Slide key={index}>{slide}</Slide>
          ))}
        </CarouselContainer>{' '}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-4">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-blue-500 border' : 'bg-gray-300'}`}
              onClick={() => setCurrentSlide(index)}
            />
          ))}
        </div>
      </CarouselWrapper>
    </>
  );
};
